import { IParameter } from '@/pages/Parameters/parameters.types.ts'
import { CSSProperties } from 'react'
import parameterDataTypeDropdownStatusConstants from './parameterDataTypeDropdown.constans'
import DropdownInput from 'src/shared/Inputs/DropdownInput'

interface IProps {
  value: IParameter['dataType']
  name: string
  onChange: (val: IParameter['dataType'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const ParameterDataTypeDropdown = (props: IProps) => {
  return (
    <DropdownInput
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      onSelect={props.onChange}
      options={parameterDataTypeDropdownStatusConstants.fieldTypeOptions as any}
      selectedOption={props.value as any}
      title={props.title || 'Выберите тип'}
    />
  )
}

export default ParameterDataTypeDropdown
